module.exports = __webpack_public_path__ + "img/Blauzahn.c9474fd9.jpg";